var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SubmissionsForProviderApprovalService from "../services/SubmissionsForProviderApprovalService";
import MemberHandbookService from "../../MemberHandbook/services/MemberHandbookService";
import Title from "../../App/components/Title";
import ModalNewRequest from "../components/ModalNewRequest";
import { handleServiceError } from "../../App/components/ErrorHandler";
import { formatDate } from "../../App/utils/formatter";
import "../styles/SubmissionsForProviderApproval.css";
import "../../App/styles/GlobalStyle.css";
import AddIcon from '@mui/icons-material/Add';
import { Pagination } from '@mui/material';
import Notification from "../../App/components/Notification";
function SubmissionsForProviderApproval() {
    var _a = useState(false), modalShowNewRequest = _a[0], setModalShowNewRequest = _a[1];
    var _b = useState(), userArts = _b[0], setUserArts = _b[1];
    var _c = useState(), materialLinkURL = _c[0], setMaterialLinkURL = _c[1];
    var _d = useState(1), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = useState(0), totalItems = _e[0], setTotalItems = _e[1];
    var _f = useState(null), paginateData = _f[0], setPaginateData = _f[1];
    var navigate = useNavigate();
    useEffect(function () {
        getAllUsersArts(20, currentPage);
        getTheMaterialLink();
    }, [20, currentPage]);
    function getAllUsersArts(perPage, page) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Block.circle("[data-id=arts-grid]");
                SubmissionsForProviderApprovalService.getAllUsersArts(20, page)
                    .then(function (res) {
                    setUserArts(res.data.arts.data);
                    setPaginateData(res.data.arts);
                    setTotalItems(res.data.arts.total);
                    Notification().Block.remove("[data-id=arts-grid]");
                }, function (error) {
                    handleServiceError(error);
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    function getTheMaterialLink() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, MemberHandbookService.memberHandbookURL().then(function (res) {
                            setMaterialLinkURL(res.data.arts_url);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    var handlePageChange = function (event, value) {
        if (value > Math.ceil(totalItems / 20)) {
            return;
        }
        setCurrentPage(value);
        getAllUsersArts(20, value);
    };
    var handleTicketHistoryClick = function (art) {
        navigate("/ticket_history/".concat(art.id));
    };
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsxs("div", __assign({ className: "header-actions-submissions-for-approval" }, { children: [_jsx(Title, { text: "Artes para aprova\u00E7\u00E3o", hr: true }), _jsxs("div", { children: [materialLinkURL ? (_jsx(Link, __assign({ to: materialLinkURL, target: "_blank" }, { children: _jsx("button", __assign({ className: "button-with-blue-border download-material-button" }, { children: "Baixar materiais" })) }))) : (_jsx("button", __assign({ className: "button-with-blue-border download-material-button" }, { children: "Baixar materiais" }))), _jsxs("button", __assign({ className: "blue-button new-request-button", onClick: function () { return (setModalShowNewRequest(true)); } }, { children: [_jsx(AddIcon, { sx: { fontSize: "20px" } }), " Nova Solicita\u00E7\u00E3o"] }))] })] })), _jsx("div", __assign({ "data-id": "arts-grid" }, { children: _jsxs("table", __assign({ className: "table-arts" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "N\u00FAmero da solicita\u00E7\u00E3o" }), _jsx("th", { children: "Assunto" }), _jsx("th", { children: "Atualizado em" }), _jsx("th", { children: "Status" })] }) }), _jsx("tbody", { children: userArts && Object.values(userArts).map(function (art, index) {
                                return (_jsxs("tr", __assign({ onClick: function () { return handleTicketHistoryClick(art); }, style: { cursor: "pointer" } }, { children: [_jsxs("td", { children: ["#", art.id] }), _jsx("td", __assign({ className: "td-custom" }, { children: art.subject_of_art })), _jsx("td", { children: formatDate(art.updated_at) }), _jsx("td", __assign({ style: { display: "flex", justifyContent: "center" } }, { children: _jsx("div", __assign({ className: "status-button", style: { backgroundColor: art.color, color: art.color !== "#0000" ? '#000000' : "inherit" } }, { children: art.art_status_translation })) }))] }), art.id));
                            }) })] })) })), _jsx(ModalNewRequest, { show: modalShowNewRequest, closeModal: function () { setModalShowNewRequest(false); } }), paginateData !== undefined && (_jsx("div", __assign({ style: { display: "flex", justifyContent: "flex-end", paddingTop: "1rem" } }, { children: _jsx(Pagination, { count: Math.ceil(totalItems / 20), page: currentPage, onChange: handlePageChange, color: "primary", showFirstButton: true, showLastButton: true }) })))] })));
}
export default SubmissionsForProviderApproval;
